import React, { useContext } from 'react';

import { UsersApi } from '../apis';
import { api } from '../api';

const UsersApiContext = React.createContext(new UsersApi(api));

export const UsersApiProvider = UsersApiContext.Provider;
export const useUsersApi = (): UsersApi => useContext(UsersApiContext);
